import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import usersApi from '../api/users.api';
import { UserContext } from './UserContext';

export const UserTagsContext = createContext();

export const UserTagsProvider = ({ children }) => {
  const { user } = useContext(UserContext);
  const [userTags, setUserTags] = useState([]);

  const syncUserTags = useCallback(() => {
    if (!user) {
      setUserTags([]);
      return Promise.resolve([]);
    }

    return usersApi.listAllTags().then(setUserTags);
  }, [user]);

  useEffect(() => {
    if (user) {
      syncUserTags();
    } else {
      setUserTags([]);
    }
  }, [syncUserTags, user]);

  const value = useMemo(
    () => ({
      userTags,
      setUserTags,
      syncUserTags,
    }),
    [userTags, syncUserTags]
  );

  return (
    <UserTagsContext.Provider value={value}>
      {children}
    </UserTagsContext.Provider>
  );
};

export const useUserTags = () => {
  const context = React.useContext(UserTagsContext);

  if (context === undefined) {
    throw new Error('useUserTags must be used within a UserTagsProvider');
  }

  return context;
};
